<template>
  <v-list
    class="transparent mt-3 py-0"
    data-cy="lista_motivos"
  >
    <template
      v-for="(item, index) in lista"
    >
      <v-list-item
        :key="index"
        :data-cy="'nao_encontrei_motivo_' + item.id"
        link
        class="pa-0 mt-1"
        @click="gravarMotivoSolicitado(item.id)"
      >
        <v-list-item-title
          class="px-0 py-3 text-wrap"
        >
          {{ item.description }}
        </v-list-item-title>

        <v-list-item-icon class="my-auto">
          <v-icon class="display-1">
            mdi-chevron-right
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-divider :key="'divider_' + index" />
    </template>
    <v-list-item
      v-if="mostrarOutros"
      href="/nao-encontrei-o-que-preciso/motivo/outros"
      :data-cy="'nao_encontrei_motivo_outros_'"
      link
      class="pa-0 mt-1"
    >
      <v-list-item-title
        class="px-0 py-3 text-wrap"
      >
        Outros
      </v-list-item-title>

      <v-list-item-icon class="my-auto">
        <v-icon class="display-1">
          mdi-chevron-right
        </v-icon>
      </v-list-item-icon>
    </v-list-item>
    <v-divider />
  </v-list>
</template>

<script>
export default {
  name: 'ListaMotivos',

  props: {
    lista: {
      type: Array,
      required: true,
    },
    mostrarOutros: {
      type: Boolean,
      default: false,
    },
    proximaPagina: {
      type: String,
      default: '',
    },
  },

  methods: {
    gravarMotivoSolicitado(id) {
      const idMotivo = {
        category: id,
      };
      Object.assign(this.$store.state.dadosCompra, idMotivo);
      const rotaProximaPagina = this.proximaPagina || '/solicitacao-de-reembolso';

      this.$router.push(rotaProximaPagina);
    },
  },
};
</script>
